import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Futura Bk BT", "Helvetica", "Arial", sans-serif',
  },
  // ... other theme configurations
});

export default theme;
